import { Global, css } from '@emotion/core'
import styled from '@emotion/styled'

const COLORS = {
	buttonBgColorHover: '#00788d',
	buttonBgColor: '#ffa06a',
	buttonTextColorHover: '#ffffff',
	cardBgColor: '#ffffff',
	cardBorderColor: '#a1a1a1',
	partnerTextColor: '#00788d',
	subheadTextColor: '#505050',
	primaryTextColor: '#003b5c',
}

const globalStyles = css`
	html,
	body {
		color: #444;
		font-weight: 400;
		font: 14px/1.21 'Helvetica Neue', arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		margin: 0;
		padding: 0;
	}

	html {
		box-sizing: border-box;

		* {
			box-sizing: inherit;
		}
	}
`

export function GlobalStyles() {
	return <Global styles={globalStyles} />
}

export const Wrapper = styled.div`
	margin: 0 auto;
	max-width: 800px;
	padding: 10px;
	text-align: center;
	height: 375px;
`

export const Headline = styled.h1`
	color: ${COLORS.primaryTextColor};
	font-size: 17px;
	margin: 0 0 10px;

	@media (min-width: 410px) {
		font-size: 20px;
	}
`

export const SubHeadline = styled.h2`
	display: none;

	@media (min-width: 625px) {
		color: ${COLORS.subheadTextColor};
		display: block;
		font-size: 14px;
		margin: 0 auto 15px;
		max-width: 600px;
	}
`

export const OfferList = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin-bottom: 10px;

	@media (min-width: 625px) {
		flex-direction: row;
	}
`

export const OfferCard = styled.div`
	align-content: center;
	align-items: center;
	background: ${COLORS.cardBgColor};
	border: 1px solid ${COLORS.cardBorderColor};
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-bottom: 10px;
	padding: 10px;
	height: 60px;

	&:last-child {
		margin-bottom: 0px;
	}

	@media (min-width: 625px) {
		flex-direction: column;
		margin: 0 10px 0 0;
		padding: 10px;
		min-height: 225px;
		width: 25%;

		&:last-child {
			margin-right: 0px;
		}
	}
`

export const OfferLogo = styled.img`
	height: 30px;

	@media (min-width: 625px) {
		height: 50px;
	}
`

export const InnerWrap = styled.div`
	align-self: left;
	margin: 0 auto 0 10px;
	display: none;
	text-align: left;
	width: 100%;

	@media (min-width: 320px) {
		display: block;
	}

	@media (min-width: 625px) {
		margin: 0;
		text-align: center;
	}
`

export const OfferPartnerName = styled.div`
	display: none;
	color: ${COLORS.partnerTextColor};

	@media (min-width: 410px) {
		display: block;
	}
`

export const OfferIntroText = styled.div`
	color: ${COLORS.primaryTextColor};
	font-weight: bold;

	@media (min-width: 625px) {
		padding: 10px 0px;
	}
`

export const VisitOfferButton = styled.a`
	background: ${COLORS.buttonBgColor};
	color: ${COLORS.primaryTextColor};
	display: block;
	flex-shrink: 0;
	font-size: 12px;
	font-weight: bold;
	letter-spacing: 1px;
	margin-left: 10px;
	padding: 12px 5px;
	text-decoration: none;
	text-transform: uppercase;
	transition: all 0.4s ease;
	width: 100px;

	@media (min-width: 410px) {
		font-size: 14px;
	}

	@media (min-width: 460px) {
		letter-spacing: 3px;
		margin: 0;
		max-height: initial;
		width: 140px;
	}

	@media (min-width: 625px) {
		width: 100%;
	}

	&:hover {
		background: ${COLORS.buttonBgColorHover};
		color: ${COLORS.buttonTextColorHover};
	}
`

export const PoweredByWrapper = styled.div`
	margin-top: 20px;
`
